var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresence = function SvgPresence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 3.385V2m3.63 2.364.978-.98M20.618 8H22M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.85 8.007h3.222c.379 0 .686.315.686.703v3.325m-13 1.923c2.273.266 7.977-.444 12.131-5.068"
  })));
};
export default SvgPresence;